import styled from "styled-components";

export const VenueSearchFormContainer = styled.div``;
